import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "@rainbow-me/rainbowkit/styles.css";
import {
  getDefaultWallets,
  RainbowKitProvider,
  midnightTheme,
} from "@rainbow-me/rainbowkit";
import { configureChains, createClient, WagmiConfig } from "wagmi";
import {
  arbitrum,
  baseGoerli,
  scrollTestnet,
  polygon,
  sepolia,
  gnosis,
  polygonZkEvmTestnet,
} from "wagmi/chains";
import { publicProvider } from "wagmi/providers/public";
import { ChakraProvider } from "@chakra-ui/react";

const mantle = {
  id: 5_001,
  name: "Mantle Testnet",
  network: "mantle",
  iconUrl:
    "https://assets.coingecko.com/coins/images/30980/standard/token-logo.png?1696529819",
  nativeCurrency: {
    decimals: 18,
    name: "Mantle",
    symbol: "MNT",
  },
  rpcUrls: {
    public: { http: ["https://rpc.testnet.mantle.xyz/"] },
    default: { http: ["https://rpc.testnet.mantle.xyz/"] },
  },
  blockExplorers: {
    etherscan: {
      name: "mantlescan",
      url: "https://explorer.testnet.mantle.xyz/",
    },
    default: {
      name: "mantlescan",
      url: "https://explorer.testnet.mantle.xyz/",
    },
  },
};

const base = {
  id: 8_453,
  name: "Base",
  network: "base",
  iconUrl:
    "https://storage.googleapis.com/ethglobal-api-production/organizations%2Fh5ps8%2Flogo%2F1678294488367_W-9qsu1e_400x400.jpeg",
  nativeCurrency: {
    decimals: 18,
    name: "Base",
    symbol: "ETH",
  },
  rpcUrls: {
    public: { http: ["https://mainnet.base.org"] },
    default: { http: ["https://mainnet.base.org"] },
  },
  blockExplorers: {
    etherscan: { name: "basescan", url: "https://basescan.org" },
    default: { name: "basescan", url: "https://basescan.org" },
  },
};

const stylus = {
  id: 23_011_913,
  name: "Arbitrum Stylus",
  network: "stylus",
  iconUrl:
    "https://assets.coingecko.com/coins/images/16547/standard/photo_2023-03-29_21.47.00.jpeg?1696516109",
  nativeCurrency: {
    decimals: 18,
    name: "Arbitrum",
    symbol: "ETH",
  },
  rpcUrls: {
    public: { http: ["https://stylus-testnet.arbitrum.io/rpc"] },
    default: { http: ["https://stylus-testnet.arbitrum.io/rpc"] },
  },
  blockExplorers: {
    etherscan: {
      name: "basescan",
      url: "https://stylus-testnet-explorer.arbitrum.io/",
    },
    default: {
      name: "basescan",
      url: "https://stylus-testnet-explorer.arbitrum.io/",
    },
  },
};

const { chains, provider } = configureChains(
  [stylus, base, polygon, polygonZkEvmTestnet, scrollTestnet, sepolia, mantle],
  [publicProvider()]
);

const { connectors } = getDefaultWallets({
  appName: "My RainbowKit App",
  projectId: "922eb14d995550ff5c7e0613a093f0d7",
  chains,
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider>
      <WagmiConfig client={wagmiClient}>
        <RainbowKitProvider
          chains={chains}
          coolMode
          theme={midnightTheme({
            fontStack: "system",
            overlayBlur: "large",
            borderRadius: "large",
          })}
        >
          <App />
        </RainbowKitProvider>
      </WagmiConfig>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
